import WithRender from "../../templates/layouts/layoutUploadPersonalizationConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getAddToCartFullPage",
      "getPersonalizationFullPage",
      "getCimpressNoQuantity"
    ])
  }
});
